import { Chip, alpha, makeStyles } from '@material-ui/core';

import { getTypeOrNull } from '@spotify/confidence-graphql';
import { useIdentity } from '@spotify/plugin-confidence-iam-react';

import type { MentionChipProps } from './MentionChip';

const useStyles = makeStyles(theme => ({
  chip: {
    pointerEvents: 'none',
    verticalAlign: 'baseline',
    backgroundColor: alpha(theme.palette.background.default, 0.5),
    marginRight: 0,
    marginBottom: 0,
  },
}));

/** @deprecated Legacy MUI copy; use MentionChip. */
export const MentionChipMui = ({ displayName, name }: MentionChipProps) => {
  const classes = useStyles();
  const { identity } = useIdentity({ name });
  const user = getTypeOrNull(identity?.user);

  return (
    <Chip
      component="span"
      size="small"
      className={classes.chip}
      label={`@${user?.fullName ?? identity?.displayName ?? displayName}`}
    />
  );
};
